import { render, staticRenderFns } from "./GoodsControl.vue?vue&type=template&id=671e82f3&scoped=true"
import script from "./GoodsControl.vue?vue&type=script&lang=js"
export * from "./GoodsControl.vue?vue&type=script&lang=js"
import style0 from "./GoodsControl.vue?vue&type=style&index=0&id=671e82f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671e82f3",
  null
  
)

export default component.exports